import { render, staticRenderFns } from "./ItemCardBasicData.vue?vue&type=template&id=3ae2629e&scoped=true"
import script from "./ItemCardBasicData.vue?vue&type=script&lang=ts"
export * from "./ItemCardBasicData.vue?vue&type=script&lang=ts"
import style0 from "./ItemCardBasicData.vue?vue&type=style&index=0&id=3ae2629e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae2629e",
  null
  
)

export default component.exports